module.exports = __webpack_public_path__ + "img/img-122.8191bd13.png";